export const collapsibleBlocksInitialState = {
	kpiAnalysis: false,
	siteParameters: true,
};
